import React, { useState } from 'react';

const LayerControl = ({ modelList, layerVisibility, onToggleVisibility, onClose }) => {
  const [searchText, setSearchText] = useState('');

  // Filter modelList based on search text
  const filteredModelList = modelList.map(group => ({
    ...group,
    models: group.models.filter(model => 
      model.name.toLowerCase().includes(searchText.toLowerCase())
    )
  })).filter(group => group.models.length > 0);

  return (
    <div className="w-full h-full flex flex-col bg-white">
      <div className="p-2 sm:p-3 flex-shrink-0 flex items-center justify-between border-b border-gray-200">
        <h2 className="text-yellow-600 text-sm sm:text-base font-bold leading-tight">Layer Control</h2>
        {onClose && (
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded p-1 transition-colors duration-200"
            title="Close panel"
          >
            <span className="text-sm font-bold">×</span>
          </button>
        )}
      </div>
      
      <div className="flex-1 overflow-y-auto px-2 sm:px-3">
        {filteredModelList.map((group, groupIndex) => (
          <CollapsibleGroup
            key={groupIndex}
            group={group}
            layerVisibility={layerVisibility}
            onToggleVisibility={onToggleVisibility}
          />
        ))}
      </div>

      {/* Search Field */}
      <div className="p-2 sm:p-3 border-t border-gray-200 flex-shrink-0">
        <div className="flex items-center">
          <input
            type="text"
            placeholder="Search layers..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="flex-1 px-2 py-2 text-sm border border-gray-300 rounded-l focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
          />
          <button
            onClick={() => setSearchText('')}
            className="text-orange-600 hover:text-orange-800 w-8 py-2 flex items-center justify-center border border-gray-300 border-l-0 rounded-r bg-gray-50 hover:bg-gray-100"
            title="Clear search"
          >
            <span className="text-sm font-bold">✕</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const CollapsibleGroup = ({ group, layerVisibility, onToggleVisibility }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="mb-1 sm:mb-2">
      {/* Group Title */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between cursor-pointer bg-gradient-to-r from-yellow-500 to-yellow-600 text-black p-1.5 sm:p-2 rounded shadow-md hover:from-yellow-400 hover:to-yellow-500 transition-all duration-200"
      >
        <span className="font-bold text-xs sm:text-xs truncate">{group.name}</span>
        <span className="text-black font-bold text-xs flex-shrink-0 ml-1">{isOpen ? '▲' : '▼'}</span>
      </div>

      {/* Models in Group */}
      {isOpen && (
        <div className="ml-0.5 sm:ml-1 mt-0.5 sm:mt-1">
          {group.models.map((model, modelIndex) => (
            <div 
              key={modelIndex} 
              className="flex items-center mb-0.5 sm:mb-1 p-1 bg-gray-100 rounded hover:bg-gray-200 transition-colors duration-200 cursor-pointer"
              onClick={() => onToggleVisibility(model.name)}
            >
              <input
                type="checkbox"
                checked={layerVisibility[model.name]?.visible || false}
                onChange={() => onToggleVisibility(model.name)}
                className="mr-1.5 sm:mr-2 w-3 h-3 sm:w-3 sm:h-3 text-yellow-500 bg-white border-gray-300 rounded focus:ring-yellow-500 focus:ring-1 pointer-events-none"
              />
              <label className="text-gray-700 text-xs font-medium cursor-pointer truncate pointer-events-none">{model.name}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerControl;
